export enum RefusRDVFormValuesEnum {
	DEMANDE_ID = 'demande_residentiel_id',
	OFFRE_ID = 'offre_residentiel_id',
	RAISON_REFUS = 'raison_refus',
	COMMENTAIRE = 'commentaire'
}